export default __webpack_public_path__ + "static/media/arrow_right-icon.1582b365.svg";